import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const whatsappNumber = '919911016163';
const whatsappText = encodeURIComponent('Hi! I would like to know more about your products.');
const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappText}`;

function getButtonStyles(isMobile) {
  return {
    position: 'fixed',
    bottom: isMobile ? 16 : 48, // 1rem (16px) for mobile, 3rem (48px) for desktop
    right: isMobile ? 16 : 48,
    zIndex: 2147483647, // max z-index for always on top
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    pointerEvents: 'auto',
  };
}

export default function WhatsAppFloatingButton() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 640);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const button = (
    <div style={{position: 'fixed', bottom: 24, right: 24, zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        style={{
          background: 'rgb(37, 211, 102)',
          borderRadius: '50%',
          boxShadow: 'rgba(37, 211, 102, 0.3) 0px 4px 24px',
          padding: 12,
          border: '3px solid white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer'
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="white">
          <g><path d="M16 3C9.373 3 4 8.373 4 15c0 2.65.868 5.11 2.356 7.133L4 29l7.099-2.326A12.95 12.95 0 0016 27c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 22c-1.855 0-3.634-.507-5.17-1.46l-.367-.22-4.223 1.384 1.384-4.223-.22-.367A9.943 9.943 0 016 15c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10zm5.29-7.71c-.29-.145-1.715-.847-1.98-.943-.265-.096-.458-.145-.652.145-.193.29-.747.943-.915 1.138-.168.193-.337.217-.626.072-.29-.145-1.225-.452-2.334-1.442-.862-.77-1.443-1.72-1.613-2.01-.168-.29-.018-.447.127-.592.13-.13.29-.337.435-.506.145-.168.193-.29.29-.483.096-.193.048-.362-.024-.507-.072-.145-.652-1.576-.893-2.16-.235-.566-.477-.49-.652-.5-.168-.007-.362-.009-.556-.009-.193 0-.507.072-.772.362-.265.29-1.01.99-1.01 2.415 0 1.425 1.034 2.803 1.178 2.997.145.193 2.036 3.111 4.936 4.242.69.297 1.227.475 1.646.607.691.22 1.32.189 1.816.115.554-.082 1.715-.7 1.957-1.376.242-.676.242-1.256.168-1.376-.072-.12-.265-.193-.554-.338z"></path></g>
        </svg>
      </a>
      <span style={{
        marginTop: 8,
        background: '#fff',
        color: '#222',
        borderRadius: 8,
        padding: '2px 12px',
        fontSize: 14,
        fontWeight: 600,
        border: '2px solid #25D366',
        boxShadow: '0 2px 10px 0 rgba(37,211,102,0.15)',
        textAlign: 'center',
        maxWidth: 140,
        letterSpacing: 0.1,
      }}>
        Chat now
      </span>
    </div>
  );

  return typeof window !== 'undefined' ? createPortal(button, document.body) : null;
}
